import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import useHttpHook from "../../Hooks/HttpHook";
import { DeleteOrder, OrderTag } from "../../utils/ApiConstant";
import { dateFormatter } from "../../utils/Helper";
import { OrderLanguage } from "../../utils/Languages";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import MainPagination from "../Common/MainPagination";
import ModalWrapper from "../Common/Portals/ModalWrapper";
import { toast } from "react-toastify";
import { showErrorToast } from "../../utils/notify";

const OrganizerOrderListPage = ({ orderList, getOrders }) => {
  const [loading, sendRequest, error] = useHttpHook();
  const { userDetails } = useSelector((state) => state.user);
  const [itemIndex, setItemIndex] = useState({ id: null });
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const location = useLocation();
  const items = orderList?.data?.itemsList || [];

  const handleDeleteOrder = async () => {
    try {
      const res = await sendRequest(`${DeleteOrder}/${itemIndex.id}`, {
        method: "delete",
      });

      if (res?.status === 1) {
        getOrders();
        setIsDeleteModal(false);
      }
    } catch (deleteError) {
      console.log(deleteError);
    }
  };

  const handleOrderTag = async (orderId) => {
    try {
      await sendRequest(`${OrderTag}`, {
        method: "put",
        data: { orderId },
      });
    } catch (tagError) {
      console.log(tagError);
    }
  };

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const getOrderLink = (orderId) =>
    `/myOrder/${orderId}?redirectUrl=${location.pathname}`;

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <div className="event-orders-table-wrap">
        {orderList !== null ? (
          items.length > 0 ? (
            <MainPagination
              getEventsMethod={getOrders}
              MainData={orderList}
              PaginationType="paginate"
            >
              <div className="event-orders-table-card event-received-orders-table-card">
                <table
                  className="event-orders-table event-received-orders-table"
                  aria-label="Received orders"
                >
                  <thead>
                    <tr>
                      <th scope="col">{OrderLanguage.Columns.eventname}</th>
                      <th scope="col">{OrderLanguage.Columns.registerdName}</th>
                      <th scope="col">{OrderLanguage.Columns.tickets}</th>
                      <th scope="col">{OrderLanguage.Columns.price}</th>
                      <th scope="col">{OrderLanguage.Columns.dateOrder}</th>
                      <th scope="col">Payment Type</th>
                      <th scope="col">{OrderLanguage.Columns.actions}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((order, index) => {
                      const isNew = order.orderTag === false;
                      const eventTitle = order.event?.title || "—";
                      const registeredName = [
                        order.billingDetails?.firstName,
                        order.billingDetails?.lastName,
                      ]
                        .filter(Boolean)
                        .join(" ");

                      return (
                        <tr
                          key={order._id || index}
                          className={`event-orders-row event-received-orders-row${
                            index % 2 === 1 ? " is-alt" : ""
                          }`}
                          data-order-id={order._id}
                        >
                          <td
                            className={`event-received-orders-cell-event${
                              isNew
                                ? " event-received-orders-cell-event--new"
                                : ""
                            }`}
                          >
                            {isNew && (
                              <span className="event-received-orders-new-badge">
                                NEW
                              </span>
                            )}
                            <span className="event-received-orders-cell-event-name">
                              {eventTitle}
                            </span>
                          </td>
                          <td>{registeredName || "—"}</td>
                          <td>{order.tickets?.length ?? 0}</td>
                          <td className="event-orders-cell-price">
                            USD {parseFloat(order.total || 0).toFixed(2)}
                          </td>
                          <td>{dateFormatter(order.createdAt)}</td>
                          <td>
                            {order?.paymentType === "emi"
                              ? "Split"
                              : order?.paymentType?.toUpperCase()}
                          </td>
                          <td className="event-orders-cell-actions">
                            {userDetails?.userType === "organizer" ? (
                              <Link
                                to={getOrderLink(order._id)}
                                className="event-received-orders-action-btn"
                                aria-label={`View order details for ${eventTitle}`}
                                onClick={() => handleOrderTag(order._id)}
                              >
                                <span
                                  className="event-received-orders-action-mark"
                                  aria-hidden="true"
                                >
                                  i
                                </span>
                              </Link>
                            ) : (
                              <Link
                                to={`/myOrder/${order._id}`}
                                className="event-received-orders-action-btn"
                                aria-label={`View order details for ${eventTitle}`}
                              >
                                <span
                                  className="event-received-orders-action-mark"
                                  aria-hidden="true"
                                >
                                  i
                                </span>
                              </Link>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </MainPagination>
          ) : (
            <div className="event-orders-table-card event-received-orders-table-card event-orders-table-card--empty">
              <div className="event-orders-empty">No received orders found</div>
            </div>
          )
        ) : null}

        {isDeleteModal && (
          <ModalWrapper
            title={OrderLanguage.DeleteOrder.title}
            clickHandler={handleDeleteOrder}
            CloseModalHandler={() => setIsDeleteModal(false)}
          >
            <span>{OrderLanguage.DeleteOrder.message}</span>
          </ModalWrapper>
        )}
      </div>
    </MainComponentWrapper>
  );
};

export default OrganizerOrderListPage;
